import { createMuiTheme as createThemeV4 } from "@material-ui/core";
import { createTheme as createThemeV5 } from "@mui/material/styles";
import { ColorUtils } from "./ColorUtils";

const TEXT_SIZE_IN_REM = 0.85

const commonComponents = {
  MuiAvatar: {
    img: {
      objectFit: "contain",
    },
  },

  MuiTableContainer: {
    root: {
      boxShadow: "none",
      borderRadius: "0.5rem",
      border: `1.5px solid ${ColorUtils.TABLE_BORDER}`,
    },
  },

  MuiTableHead: {
    root: {
      maxHeight: "54px",
    },
  },

  MuiTableCell: {
    root: {
      height: "51px",
      color: `${ColorUtils.FONT_LIGHT_GRAY} !important`,
      padding: 0,
      textAlign: "center",
      fontSize: "0.85rem !important",
      lineHeight: "1.5rem",
      "& a": {
        color: `${ColorUtils.BLUE_LINK} !important`,
      },
      "&:first-of-type": {
        textAlign: "left",
        paddingLeft: "2.75rem",
      },

      "& .MuiListItemText-primary":{
        fontSize: "0.8rem",
        textAlign: "center",
      }
    },
    head: {
      fontWeight: "bold",
      backgroundColor: `${ColorUtils.TABLE_HEADER} !important`,
      whiteSpace: "nowrap",
      height: "54px",
      "&:not(:first-of-type) span": {
        justifyContent: "center",
      },
    },
  },

  MuiCheckbox: {
    root: {
      padding: "0.25rem",
      width: "1.5rem",
      height: "1.5rem",
      "& .MuiSvgIcon-root": {
        width: "1.5rem",
        height: "1.5rem",
        zIndex: 1,
      },
      //Changing the tick color
      "& .PrivateSwitchBase-input[checked]": {
        width: "auto",
        height: "auto",
        top: "auto",
        left: "auto",
        opacity: "1",
        "&::before": {
          content: "''",
          position: "absolute",
          background: "#fff !important",
          height: "100%",
          width: "100%",
        },
      },
    },
  },

  

  MuiTablePagination: {
    toolbar: {
      justifyContent: "flex-end",
      marginRight: "1rem",
    },
  },
};

const commonPalette = {
  primary: {
    main: ColorUtils.DARK_OOO,
    dark: ColorUtils.DARK_OOO,
  },
  secondary: {
    main: ColorUtils.STRONG_ENSOLVERS_ORANGE,
    dark: ColorUtils.ENSOLVERS_SECONDARY,
  },
};

const commonTypography = {
  fontFamily: "Kanit",
  fontSize: TEXT_SIZE_IN_REM * parseFloat(getComputedStyle(document.documentElement).fontSize), //convert rem to px
  body1: {
    fontSize: "0.85rem", // Custom font size for body1 variant
  },
};

const mapComponentStyles = (components: any, version: 4 | 5) => {
  if (version === 4) return components;

  const styleOverrides: Record<string, any> = {};

  return Object.keys(components).reduce((styleOverrides, componentName) => {
    styleOverrides[componentName] = {
      styleOverrides: components[componentName],
    };
    return styleOverrides;
  }, styleOverrides);
};

export const themeV4 = createThemeV4({
  overrides: mapComponentStyles(commonComponents, 4),
  palette: commonPalette,
  typography: commonTypography,
});

export const themeV5 = createThemeV5({
  components: mapComponentStyles(commonComponents, 5),
  palette: commonPalette,
  typography: commonTypography,
});
